module.exports = __webpack_public_path__ + "img/partner5.ebfa97c7.png";